/**
 * 判断值是否为数组
 * @return 是否为数组
 */
function isArray$1(value) {
    return Array.isArray(value);
}

export { isArray$1 as default };
//# sourceMappingURL=is-array.js.map
